<template>
    <span class="group-subtitle text-secondary-text">
        <slot></slot>
    </span>
</template>

<style scoped lang="scss">
    .group-subtitle {
        color: var(--secondary-text, #3D4D5C);
        font-family: "Proxima Nova", serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
    }

</style>